<template>
  <b-modal
    id="cancel-subscription-modal"
    ref="modal"
    title="Cancel Subscription"
    ok-variant="danger"
    ok-title="Yes, Cancel"
    @ok="handleSubmit"
    @hidden="resetForm"
  >
    <div v-if="subscription">
      <b-alert show variant="warning">
        <i class="fas fa-exclamation-triangle"></i>
        Are you sure you want to cancel this subscription?
      </b-alert>

      <b-card class="mb-3" bg-variant="light">
        <p class="mb-1"><strong>Customer:</strong> {{ subscription.customer.name }}</p>
        <p class="mb-1"><strong>Package:</strong> {{ subscription.package.name }}</p>
        <p class="mb-0"><strong>Valid Until:</strong> {{ subscription.end_date | date }}</p>
      </b-card>

      <b-form>
        <b-form-group label="Reason for Cancellation">
          <b-form-textarea v-model="form.reason" rows="3" placeholder="Optional..." />
        </b-form-group>
      </b-form>

      <b-alert show variant="info" class="mb-0">
        The subscription will remain active until {{ subscription.end_date | date }}
      </b-alert>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'CancelSubscriptionModal',

  data() {
    return {
      subscription: null,
      form: {
        reason: null
      }
    }
  },

  methods: {
    show(subscription) {
      this.subscription = subscription;
      this.$refs.modal.show();
    },

    async handleSubmit(event) {
      event.preventDefault();

      try {
        await axios.post(`/api/subscriptions/${this.subscription.id}/cancel`, this.form);

        this.$bvToast.toast('Subscription cancelled successfully', {
          title: 'Success',
          variant: 'success'
        });

        this.$emit('cancelled');
        this.$refs.modal.hide();
      } catch (error) {
        this.$bvToast.toast(error.response?.data?.message || 'Failed to cancel subscription', {
          title: 'Error',
          variant: 'danger'
        });
      }
    },

    resetForm() {
      this.subscription = null;
      this.form = {
        reason: null
      };
    }
  }
}
</script>
